export default __webpack_public_path__ + "static/media/trendUp.1f63263e.svg";